import {
    CREATE_CUTTING_DC_INWARD_MASTER_REQUEST,
    CREATE_CUTTING_DC_INWARD_MASTER_SUCCESS,
    CREATE_CUTTING_DC_INWARD_MASTER_FAILURE,
    DELETE_CUTTING_DC_INWARD_MASTER_REQUEST,
    DELETE_CUTTING_DC_INWARD_MASTER_SUCCESS,
    DELETE_CUTTING_DC_INWARD_MASTER_FAILURE,
    FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_REQUEST,
    FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_SUCCESS,
    FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_FAILURE,
    FETCH_CUTTING_DC_INWARD_MASTER_REQUEST,
    FETCH_CUTTING_DC_INWARD_MASTER_SUCCESS,
    FETCH_CUTTING_DC_INWARD_MASTER_FAILURE,
    UPDATE_CUTTING_DC_INWARD_MASTER_REQUEST,
    UPDATE_CUTTING_DC_INWARD_MASTER_SUCCESS,
    UPDATE_CUTTING_DC_INWARD_MASTER_FAILURE,
    RESET_CUTTING_DC_INWARD_MASTER_INFO,
    CREATE_CUTTING_DC_INWARD_MASTER_FORM,
    UPDATE_CUTTING_DC_INWARD_MASTER_FORM,
    NAVIGATE_CUTTING_DC_INWARD_DETAILS,
    NAVIGATE_CUTTING_DC_INWARD_MASTER,
    FETCH_PENDING_CUTTING_PO_IN_INWARD_REQUEST,
    FETCH_PENDING_CUTTING_PO_IN_INWARD_SUCCESS,
    FETCH_PENDING_CUTTING_PO_IN_INWARD_FAILURE,
    SET_ACTIVE_KEY_CUTTING_INWARD,
    RESET_FORM_DATA_WITHOUT_CUTTING_INWARD_ID,
    SET_END_DATE_CUTTING_DC_INWARD,
    SET_START_DATE_CUTTING_DC_INWARD,
    SET_UNIT_NAME_CUTTING_DC_INWARD
} from './cuttingDcInwardHeader.actionsType';

export const CUTTING_DC_INWARD_MASTER = 'cuttingDcInwardHeader';

let initialState = {
    loading: false,
    cuttingDcInwardHeader: [],
    pendingCuttingInward: [],
    activeKey: 1,
    cuttingInwardId: '',
    cuttingDcInwardHeaderForm: {
        fldSupplierInvoiceNo: null,
        fldSupplierInvoiceDate: null,
        fldSupplierInvoiceValue: null,
        fldSupplierDCNo: null,
        fldSupplierDCDate: null,
        fldSupplierName: '',
        fldDiscountValue: 0,
        fldItemsTotalValue: 0,
        fldIsInHouseDelivery: false,
        fldFKDeliveryAt: '',
        fldFKSupplierID: '',
        fldSupplierDCValue: null
    },
    selectedState: {},
    typeOfPoList: [],
    sourceList: [],
    departmentList: [],
    deliveryAt: [],
    errorMessage: '',
    singleCuttingDcInwardData: {},
    isCuttingDcInwardDetails: false,
    goBack: true,
    unitId: '',
    startDate: new Date().setDate(new Date().getDate() - 15),
    endDate: new Date(),

};

export let cuttingDcInwardHeaderReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_CUTTING_DC_INWARD_MASTER_REQUEST:
        case FETCH_PENDING_CUTTING_PO_IN_INWARD_REQUEST:
        case CREATE_CUTTING_DC_INWARD_MASTER_REQUEST:
        case UPDATE_CUTTING_DC_INWARD_MASTER_REQUEST:
        case FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_REQUEST:
        case DELETE_CUTTING_DC_INWARD_MASTER_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_CUTTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardHeader: updatePayload
            };
        case FETCH_PENDING_CUTTING_PO_IN_INWARD_SUCCESS:
            return {
                ...state,
                loading: false,
                pendingCuttingInward: updatePayload
            };
        case CREATE_CUTTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                },
                cuttingInwardId: updatePayload[0],
                activeKey: updatePayload[0]?.fldID ? 2 : 1
            };
        case UPDATE_CUTTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                }
            };
        case FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardHeaderForm: {
                    ...payload,
                    fldSupplierInvoiceDate: payload?.fldSupplierInvoiceDate && payload?.fldSupplierInvoiceDate.split('T')[0],
                    fldSupplierDCDate: payload?.fldSupplierDCDate && payload?.fldSupplierDCDate.split('T')[0]
                }
            };
        case DELETE_CUTTING_DC_INWARD_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                cuttingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                }
            };
        case SET_ACTIVE_KEY_CUTTING_INWARD:
            return {
                ...state,
                loading: false,
                activeKey: payload
            };
        case RESET_CUTTING_DC_INWARD_MASTER_INFO:
            return {
                ...state,
                cuttingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,
                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                },
                cuttingInwardId: '',
                activeKey: 1
            };
        case RESET_FORM_DATA_WITHOUT_CUTTING_INWARD_ID:
            return {
                ...state,
                cuttingDcInwardHeaderForm: {
                    fldSupplierInvoiceNo: null,
                    fldSupplierInvoiceDate: null,
                    fldSupplierInvoiceValue: null,
                    fldSupplierDCNo: null,
                    fldSupplierDCDate: null,
                    fldSupplierName: '',
                    fldDiscountValue: 0,
                    fldItemsTotalValue: 0,

                    fldIsInHouseDelivery: false,
                    fldFKDeliveryAt: '',
                    fldFKSupplierID: '',
                    fldSupplierDCValue: null
                },
                selectedTeam: {}
            };
        case CREATE_CUTTING_DC_INWARD_MASTER_FORM:
        case UPDATE_CUTTING_DC_INWARD_MASTER_FORM:
            return {
                ...state,
                loading: false,
                cuttingDcInwardHeaderForm: {
                    ...state.cuttingDcInwardHeaderForm,
                    [payload.key]: payload.value
                }
            };
        case FETCH_CUTTING_DC_INWARD_MASTER_FAILURE:
        case FETCH_PENDING_CUTTING_PO_IN_INWARD_FAILURE:
        case CREATE_CUTTING_DC_INWARD_MASTER_FAILURE:
        case UPDATE_CUTTING_DC_INWARD_MASTER_FAILURE:
        case FETCH_SINGLE_CUTTING_DC_INWARD_MASTER_FAILURE:
        case DELETE_CUTTING_DC_INWARD_MASTER_FAILURE:
            return {
                ...state,
                loading: false
            };
        case NAVIGATE_CUTTING_DC_INWARD_DETAILS:
            return {
                ...state,
                isCuttingDcInwardDetails: true,
                singleCuttingDcInwardData: updatePayload.singleCuttingDcInwardData
            };
        case NAVIGATE_CUTTING_DC_INWARD_MASTER:
            return {
                ...state,
                isCuttingDcInwardDetails: false,
                goBack: false
            };
        case SET_UNIT_NAME_CUTTING_DC_INWARD:
            return {
                ...state,
                unitId: payload
            };
        case SET_START_DATE_CUTTING_DC_INWARD:
            return {
                ...state,
                startDate: payload
            };
        case SET_END_DATE_CUTTING_DC_INWARD:
            return {
                ...state,
                endDate: payload
            };
        default:
            return state;
    }
};
